import CodeInput from './CodeInput'
export { CodeInput }
export default CodeInput
